module.exports = __webpack_public_path__ + "assets/icon-gate-cattleyardGate.80bec59a.svg";